import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import _ from "lodash";
import { useMemo } from "react";

export default function useTierOptions(withCustom = true) {
  const featureFlags = useFeatureFlag();
  const globalSettings = useGlobalSettingsContext();
  const tierBasedTags = globalSettings.tierBasedTags;

  const memoizedOptions = useMemo(
    () =>
      featureFlags.RISK_TIERS
        ? [
            ..._.map(tierBasedTags, (tier) => ({
              value: tier.id,
              label: tier.name,
            })),
            ...(withCustom ? [{ label: "Custom", value: "custom" }] : []),
          ]
        : [],
    [featureFlags.RISK_TIERS, tierBasedTags, withCustom],
  );

  return memoizedOptions;
}
